@if (isViewOptionCardOpen) {
  <div class="d-flex gap-2">
    <div class="d-flex button-group">
      <button nz-button nzType="default" (click)="previousDate()">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
      </button>
    </div>
    <div class="wrapper">
      <p class="mb-0">
        {{ 'page.shift_timeline.date_picker_title' | translate }}
      </p>
      <nz-date-picker
        wilsonUseLocalizedDateFormat
        [nzSeparator]="'-'"
        [nzAllowClear]="false"
        [nzInputReadOnly]="true"
        [nzDateRender]="dateRender"
        [(ngModel)]="selectedDate"
        (ngModelChange)="onCalendarChange($event)"
      ></nz-date-picker>
    </div>
    <div class="d-flex button-group">
      <button nz-button nzType="default" (click)="nextDate()">
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </button>
    </div>
  </div>
}

<ng-template #dateRender let-current>
  @let zoomLevel = zoomLevel$ | async;
  <div
    class="ant-picker-cell-inner"
    [class.not-selected]="hoveredDate"
    [class.previous-selected]="
      hoveredDate
        ? false
        : (selectedDate | isDateHighlighted: current : zoomLevel)
    "
    [class.highlighted]="hoveredDate | isDateHighlighted: current : zoomLevel"
    [class.current-highlighted]="hoveredDate === current"
    (mouseenter)="setHoverDate(current)"
    (mouseleave)="setHoverDate(null)"
    (click)="setHoverDate(null)"
  >
    {{ current.getDate() }}
  </div>
</ng-template>
